import { trackNavigationClick } from '@ecomm/cdp-tracking'
import { ContentfulImage } from '@ecomm/contentful/components'
import classNames from 'classnames'
import { useTracking } from 'react-tracking'
import { includeImage } from '../../lib/utils'
import { PHONE_NUMBER_SPECIALIST } from './data'
import type { HeaderRedesignSchema } from './schema'

type CallSpecialistDropdownMenuProps = Pick<HeaderRedesignSchema, 'images'> & {
  readonly onToggleDropdown: (close?: boolean) => void
  readonly showDropdown: boolean
  // (sideNav === true) => This dropdown menu is being displayed in the side nav and not in desktop mode
  readonly sideNav: boolean
}

export function CallSpecialistDropdownMenu({
  images,
  showDropdown,
  sideNav,
  onToggleDropdown
}: CallSpecialistDropdownMenuProps) {
  const { trackEvent } = useTracking()
  const trackClick = (label: string) => {
    trackEvent({
      event: 'navigation-link',
      eventAction: 'click',
      eventCategory: 'navigation',
      label: label
    })
    trackNavigationClick({
      action: 'click',
      navElement: label
    })
  }

  const menuImage = includeImage({ imageId: '6UMbGUo2vMm65W8HkHT2ni' }, images)

  return (
    <div
      aria-hidden={!showDropdown}
      className={classNames(
        "rounded-lg py-6 px-5 text-neutral-black bg-neutral-black top-[60px] z-10 w-full shadow-[rgba(0,0,15,0.3)_-3px_4px_4px_0px] border border-solid border-slate-100 before:absolute before:-top-1 before:left-1/2 before:z-[0] before:block before:h-6 before:w-6 before:-translate-x-1/2 before:rotate-45 before:transform before:bg-white min-[1126px]:absolute min-[1126px]:left-1/2 min-[1126px]:w-max min-[1126px]:-translate-x-1/2 min-[1126px]:bg-white min-[1126px]:before:content-['']",
        !sideNav && 'transition-[transform,opacity] duration-150',
        !sideNav &&
          (showDropdown
            ? 'translate-y-0 opacity-100'
            : 'pointer-events-none -translate-y-3 opacity-0'),
        sideNav && 'block'
      )}
      data-testid="callspecialist-dropdown-menu"
    >
      <div className="flex">
        <div className="mr-4">
          <div className="text-sm font-normal opacity-90">
            Call A Sales Specialist
          </div>
          <a
            className="font-bold text-xl hover:underline no-underline text-neutral-black"
            href={`tel:${PHONE_NUMBER_SPECIALIST}`}
            onClick={() => {
              onToggleDropdown(true)
              trackClick(PHONE_NUMBER_SPECIALIST)
            }}
            rel="noreferrer"
            tabIndex={showDropdown ? 0 : -1}
          >
            {PHONE_NUMBER_SPECIALIST}
          </a>
        </div>
        {menuImage.image ? (
          <div className="-mt-1">
            <ContentfulImage
              classNameOverride="bg-transparent"
              {...menuImage.image}
              height={50}
              quality={90}
              width={50}
            />
          </div>
        ) : null}
      </div>

      <div className="flex items-center mt-2">
        <div className="h-2 w-2 bg-complementary-sage-100 border-solid border border-gray-800 rounded"></div>
        <span className="ml-1 text-sm font-normal opacity-90">
          Available 8am-10pm, ET
        </span>
      </div>
    </div>
  )
}
